import React from "react";
import PropTypes from "prop-types";
import ReactModal from "react-modal";
import styled, { keyframes } from "styled-components";
import { MODAL_STYLES } from "../../constants";

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 28px 36px;
  gap: 14px;
`;

const Spinner = styled.div`
  width: 36px;
  height: 36px;
  border: 4px solid #f3f4f6;
  border-top-color: #ce0e2d;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const Label = styled.p`
  margin: 0;
  font-size: 0.95em;
  color: #333;
  font-weight: 600;
`;

const VehiclesLoadingModal = React.memo(({ isOpen }) => {
  return (
    <ReactModal
      isOpen={isOpen}
      style={MODAL_STYLES}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      appElement={document.getElementById("root")}
    >
      <Container>
        <Spinner />
        <Label>Loading vehicles…</Label>
      </Container>
    </ReactModal>
  );
});

VehiclesLoadingModal.displayName = "VehiclesLoadingModal";

VehiclesLoadingModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default VehiclesLoadingModal;
